const eventsList = [
  'keypress',
  'mousemove',
  'mousedown',
  'scroll',
  'touchmove',
  'pointermove'
]

export const addEventListeners = (listener) => {
  eventsList.forEach((currentEvent) => {
    window.addEventListener(currentEvent, listener, false)
  })
}

export const removeEventListeners = (listener) => {
  if (listener) {
    eventsList.forEach((currentEvent) => {
      window.removeEventListener(currentEvent, listener, false)
    })
  }
}